'use strict';

const checkIsTruncated = (ref) => {
  if (ref.current) {
    return ref.current.scrollWidth > ref.current.clientWidth;
  }
  return false;
};

module.exports = checkIsTruncated;
//# sourceMappingURL=checkIsTruncated.cjs.js.map
